import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './VerticalNav.css';
import logo from '../assets/logo.svg';
import logoP from '../assets/logo.png';
import { FaBars } from 'react-icons/fa';

const VerticalNav = ({ activeLink }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  const proyectosRef = useRef(null);
  const hasNavigatedRef = useRef(false);

  const navigate = useNavigate();

  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  const closeDropdown = () => setIsDropdownOpen(false);

  // 🔹 Cierra el menú si haces clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // 🔹 Navegación automática por swipe (solo móvil)
  useEffect(() => {
    if (!isMobile || !proyectosRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (
          entry.isIntersecting &&
          !hasNavigatedRef.current &&
          !isDropdownOpen
        ) {
          hasNavigatedRef.current = true;
          navigate('/clientes/fotovoltaicos');
        }
      },
      { threshold: 0.7 }
    );

    observer.observe(proyectosRef.current);

    return () => observer.disconnect();
  }, [isMobile, isDropdownOpen, navigate]);

  return (
    <nav
      className={`vertical-nav ${
        activeLink === '/nosotros' ? 'nav-transparent' : 'nav-with-bg'
      } ${activeLink}`}
    >
      {activeLink !== '/nosotros' && (
        <Link to="/nosotros" className="logo-link">
          <img src={logo} alt="Logo principal" className="logo" />
          <img src={logoP} alt="Logo alternativo" className="logo-small" />
        </Link>
      )}

      <ul ref={dropdownRef}>
        <li className={activeLink === '/nosotros' ? 'active' : ''}>
          <Link to="/nosotros" onClick={closeDropdown}>
            <span>Nosotros</span>
          </Link>
        </li>

        <li className={activeLink === '/servicios' ? 'active' : ''}>
          <Link to="/servicios" onClick={closeDropdown}>
            <span>Servicios</span>
          </Link>
        </li>

        {/* 🔹 PROYECTOS */}
        <li
          ref={proyectosRef}
          className={`has-submenu ${
            activeLink.startsWith('/clientes') || isDropdownOpen ? 'active' : ''
          } ${isDropdownOpen ? 'open' : ''}`}
        >
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault(); // evita navegación
              hasNavigatedRef.current = true; // evita auto-navegación
              setIsDropdownOpen((prev) => !prev);
            }}
          >
            <span className="dropdown-label">
              Proyectos <FaBars className="menu-icon" />
            </span>
          </Link>

          <ul className="submenu">
            <li
              className={
                activeLink === '/clientes/fotovoltaicos' ? 'active' : ''
              }
            >
              <Link
                to="/clientes/fotovoltaicos"
                onClick={closeDropdown}
              >
                Fotovoltaicos
              </Link>
            </li>

            <li
              className={
                activeLink === '/clientes/termosolares' ? 'active' : ''
              }
            >
              <Link
                to="/clientes/termosolares"
                onClick={closeDropdown}
              >
                Termosolares
              </Link>
            </li>
          </ul>
        </li>

        <li className={activeLink === '/contacto' ? 'active' : ''}>
          <Link to="/contacto" onClick={closeDropdown}>
            <span>Contacto</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default VerticalNav;
